import { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Private_Routes } from '../../../../main/constants';
import FormErrorMessage from '../../../shared/components/forms/FormErrorMessage';
import { Contact } from '../../../../domain/customerContact/Contact';
import { CreateContact } from '../../../../domain/customerContact/createContact';
import { ContactRepository } from '../../../../infrastructure/repositories/customer-contacts/contactRepository';
import { UpdateContact } from '../../../../domain/customerContact/updateContact';
import ContactSection from './ContactSection';

interface Props {
    isNewContact: boolean;
    contact?: Contact | null;
}

export const ContactForm = ({ isNewContact, contact: selectedContact }: Props) => {
    const initialState = selectedContact ?? {
        id: 0,
        customerId: 0,
        customerName: '',
        email: '',
        documentNumber: '',
        firstName: '',
        middleName: '',
        lastName: '',
        surname: '',
        cellphoneNumber: '',
        documentTypeId: 0,
        documentTypeName: '',
        phoneNumber: '',
        cityName: '',
        cityId: null,
        position: '',
    };

    const [contact, setContact] = useState<Contact>(initialState);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [isIncomplete, setIsIncomplete] = useState(true);

    const navigate = useNavigate();
    const { id } = useParams<{ id: string }>();

    const handleInputChange = (
        name: string,
        value: string | boolean | number[] | number | undefined | null
    ) => {
        setContact({ ...contact, [name]: value });
    };

    const handleError = (error: any) => {
        setErrorMessage(error.response.data);
        setIsSubmitting(false);
        window.scrollTo({ behavior: 'smooth', left: 0, top: 0 });
    };

    const handleSubmit = (event: React.FormEvent) => {
        event.preventDefault();

        setIsSubmitting(true);
        setErrorMessage('');

        if (isNewContact) {
            let body: CreateContact = {
                cityId: contact.cityId,
                email: contact.email,
                phoneNumber: contact.phoneNumber,
                cellphoneNumber: contact.cellphoneNumber,
                firstName: contact.firstName,
                middleName: contact.middleName,
                lastName: contact.lastName,
                surname: contact.surname,
                customerId: contact.customerId,
                position: contact.position,
            };

            ContactRepository.CreateContact(body)
                .then((response) => {
                    navigate(
                        `/customers/contacts/contacts-list/${contact.customerId}`
                    );
                    setIsSubmitting(false);
                })
                .catch(handleError);
        } else {
            let body: UpdateContact = {
                cityId: contact.cityId,
                email: contact.email,
                phoneNumber: contact.phoneNumber,
                cellphoneNumber: contact.cellphoneNumber,
                firstName: contact.firstName,
                middleName: contact.middleName,
                lastName: contact.lastName,
                surname: contact.surname,
                customerId: contact.customerId,
                position: contact.position,
            };

            ContactRepository.UpdateContact(body, contact.id)
                .then((response) => {
                    navigate(
                        `/customers/contacts/contacts-list/${contact.customerId}`
                    );
                    setIsSubmitting(false);
                })
                .catch(handleError);
        }
    };

    useEffect(() => {
        if (
            contact.firstName !== '' &&
            contact.lastName !== '' &&
            contact.email !== ''
        ) {
            setIsIncomplete(false);
        } else {
            setIsIncomplete(true);
        }
    }, [contact]);
    return (
        <div>
            <FormErrorMessage errorMessage={errorMessage} />
            <div className='row'>
                <div className='col-xxl-12'>
                    <div className='card '>
                        <div className='card-body p-4'>
                            <div className='row'>
                                <ContactSection
                                    isNewContact={isNewContact}
                                    contact={contact}
                                    onChange={handleInputChange}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className='d-flex gap-2'>
                    <button onClick={() => navigate(-1)} className='btn btn-withe'>
                        <i className='mdi mdi-arrow-left'></i> Atrás
                    </button>

                    {isNewContact ? (
                        <button
                            className='btn btn-primary'
                            disabled={isSubmitting || isIncomplete}
                            onClick={handleSubmit}
                        >
                            {isSubmitting ? 'Creando...' : 'Crear'}
                        </button>
                    ) : (
                        <button
                            className='btn btn-primary'
                            disabled={isSubmitting || isIncomplete}
                            onClick={handleSubmit}
                        >
                            <i className='ri-arrow-up-circle-line'></i>
                            {isSubmitting ? 'Actualizando...' : 'Actualizar'}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};
